import React from 'react'


import {
    ListContainer,
    ListHeading,
    ListTitle,
    ListDivider,
    ListRow,
    InfoList,
    ListItemHeader,
    CheckIcon,
    CrossIcon,
    VehicleIcon,
    VehicleTypeItemAvailability,
    VehicleTypeItem,
    VehicleTypeName,
    VehicleTypeSubName,
    VehicleTypeNameShorter
} from './VehicleInfoList.styles'
import { VehicleTypesSetting } from '~/dataModels/ProductModels';


interface VehicleTypeListProps{
    title: string
    availableTypes: string[]
}

const VehicleTypeList = ({title,availableTypes}:VehicleTypeListProps) =>{

    return (
        <ListContainer>
        <ListHeading>
            <ListTitle>
                {title}
            </ListTitle>
        </ListHeading>
        <ListDivider />
        <InfoList>
            <ListRow>
                <ListItemHeader>
                    <VehicleTypeItem>
                        <VehicleIcon name="car" size="huge" />
                        <VehicleTypeName>Car</VehicleTypeName>
                        <VehicleTypeSubName>Max 6 characters</VehicleTypeSubName>
                    </VehicleTypeItem>
                    <VehicleTypeItemAvailability>
                        {
                            availableTypes.includes(VehicleTypesSetting.Car.name.toLowerCase()) ?
                            <CheckIcon name="check circle" size="huge" color="green"/> :
                            <CrossIcon name="times circle" size="huge" color="orange"/>
                        }
                    </VehicleTypeItemAvailability>
                </ListItemHeader>
            </ListRow>
            <ListRow>
                <ListItemHeader>
                    <VehicleTypeItem>
                        <VehicleIcon name="motorcycle" size="huge" />
                        <VehicleTypeName>Motorbike</VehicleTypeName>
                        <VehicleTypeSubName>Max 5 characters</VehicleTypeSubName>
                    </VehicleTypeItem>
                    <VehicleTypeItemAvailability>
                        {
                            availableTypes.includes(VehicleTypesSetting.Motorbike.name.toLowerCase()) ?
                            <CheckIcon name="check circle" size="huge" color="green"/> :
                            <CrossIcon name="times circle" size="huge" color="orange"/>
                        }
                    </VehicleTypeItemAvailability>
                </ListItemHeader>
            </ListRow>
            <ListRow>
                <ListItemHeader>
                    <VehicleTypeItem>
                        <div className='flex flex-row'>
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="49" height="17" viewBox="0 0 49 17" fill="none" style={{padding: '0px'}}>
                                <path d="M41.9161 8.84781H34.2639C34.2639 10.3846 33.0181 11.6304 31.4813 11.6304H25.9161C25.9161 8.17261 23.113 5.36956 19.6552 5.36956C18.3681 5.36956 17.1718 5.75797 16.1769 6.42384C15.1821 5.75788 13.9858 5.36956 12.6987 5.36956C9.24088 5.36956 6.43783 8.17261 6.43783 11.6304H3.6552C2.11836 11.6304 0.872559 10.3846 0.872559 8.84781V1.89132C0.872559 1.1229 1.49546 0.5 2.26388 0.5H32.8725C33.6409 0.5 34.2638 1.1229 34.2638 1.89132V6.06517H46.7854C47.5539 6.06517 48.1768 6.68807 48.1768 7.45649C48.1768 8.22491 47.5539 8.84781 46.7854 8.84781H44.6985V10.9347C44.6985 11.7032 44.0756 12.3261 43.3072 12.3261C42.5388 12.3261 41.9159 11.7032 41.9159 10.9347V8.84781H41.9161ZM16.177 8.22241C17.0609 7.32049 18.2927 6.76088 19.6553 6.76088C22.3446 6.76088 24.5249 8.94103 24.5249 11.6304C24.5249 14.3198 22.3447 16.5 19.6553 16.5C18.2927 16.5 17.0609 15.9404 16.177 15.0385C15.2932 15.9404 14.0614 16.5 12.6988 16.5C10.0095 16.5 7.82924 14.3198 7.82924 11.6304C7.82924 8.94112 10.0094 6.76088 12.6988 6.76088C14.0614 6.76079 15.2932 7.3204 16.177 8.22241ZM12.6988 13.7174C13.8514 13.7174 14.7857 12.783 14.7857 11.6304C14.7857 10.4779 13.8514 9.54351 12.6988 9.54351C11.5462 9.54351 10.6119 10.4779 10.6119 11.6304C10.6119 12.783 11.5462 13.7174 12.6988 13.7174ZM19.6553 13.7174C20.8079 13.7174 21.7422 12.783 21.7422 11.6304C21.7422 10.4779 20.8079 9.54351 19.6553 9.54351C18.5027 9.54351 17.5684 10.4779 17.5684 11.6304C17.5684 12.783 18.5027 13.7174 19.6553 13.7174Z" fill='black'/>
                            </svg></span>
                            <VehicleTypeNameShorter>Trailer</VehicleTypeNameShorter>
                        </div>
                        <VehicleTypeSubName>Max 5 characters</VehicleTypeSubName>
                    </VehicleTypeItem>
                    <VehicleTypeItemAvailability>
                        {
                            availableTypes.includes(VehicleTypesSetting.Trailer.name.toLowerCase()) ?
                            <CheckIcon name="check circle" size="huge" color="green"/> :
                            <CrossIcon name="times circle" size="huge" color="orange"/>
                        }
                    </VehicleTypeItemAvailability>
                </ListItemHeader>
            </ListRow>
        </InfoList>
    </ListContainer>
    );
}

export default VehicleTypeList;